import EFPicture from 'elem/compCommon/EFPicture';
import { createPortal } from 'react-dom';
import css from './index.module.scss';
import RulesModal from './RulesModal';
import { useGlobal } from '@/utils/useGlobal';
import { signupCookie } from '@/utils/cookies/signupCookie';

export default function M() {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('RV');
    const { locale, query } = useRouter();
    const now = new Date().getTime();
    const memberStart = new Date('2024/05/30 15:00:00 GMT+8').getTime();
    const memberEnd = new Date('2024/06/11 15:00:00 GMT+8').getTime();
    const summerPromotionStart = new Date('2024/06/03 15:00:00 GMT+8').getTime();
    const summerPromotionEnd = new Date('2024/07/22 16:00:00 GMT+8').getTime();
    const SHOW_MEMBER = (memberStart <= now && now < memberEnd) || query?.member === 'true';
    const SHOW_SUMMER = (summerPromotionStart <= now && now < summerPromotionEnd) || query?.summer === 'true';
    const [showModal, setShowModal] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const IMG = {
        '1920': 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717079994278/8.png',
        '768': 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080047086/8_768.png',
        '375': 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080060534/8_375.png',
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div id="RV-N" className={`RV-N RV-box ${css['RV-N']}`}>
            {SHOW_MEMBER && (
                <>
                    <div className="info-box">
                        <p className="title">{t('N_title')}</p>
                    </div>
                    <div className="wrapper">
                        <div className="msg-box">
                            <p className="msg-title">{t('N_date')}</p>
                            <p className="msg-desc">
                                <span>{t('N_desc')}</span>{' '}
                                <span className="rule" onClick={() => setShowModal(true)}>
                                    {t('N_rules')}
                                </span>
                            </p>
                            <Link
                                className="register"
                                onClick={() => {
                                    signupCookie?.({
                                        sector_name: t('N_title'),
                                        entry_position: 7,
                                    });
                                }}
                                href={`/register?redirect=https://www.ecoflow.com/${locale}/on-the-road-power-solution`}
                            >
                                {t('N_register')}
                            </Link>
                        </div>
                        <div className="img-box">
                            <EFPicture src={IMG['1920']} srcPad={IMG['768']} srcMobile={IMG['375']} alt={t('N_title')} />
                        </div>
                    </div>
                </>
            )}
            {SHOW_SUMMER && (
                <div className={`note-box ${SHOW_MEMBER ? 'has-member' : ''}`}>
                    <p className="tip">{t('N_tip')}</p>
                    <Link
                        className="more"
                        href={`https://${locale}.ecoflow.com/pages/summer-sale?utm_source=brandsite&utm_medium=pillar-page&utm_campaign=summer-sale`}
                        target="_blank"
                    >
                        {t('N_more')}
                    </Link>
                </div>
            )}
            {isClient && showModal && createPortal(<RulesModal callback={() => setShowModal(false)} />, document.body)}
        </div>
    );
}
